$(function() {
  $('input[name="phone-number"]').mask('000.000.0000');
  function confirmEmailValidation() {
    var email = $('.emailaddress').val();
    var confirmemail = $('.confirmemailaddress').val();
    var pattern = /^([\w-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

    $('.confirmemailtxtvalid').addClass('hidden');
    $('.emailtxtvalid').addClass('hidden');
    $('.emailtxt').addClass('hidden');
    $('.confirmemailtxt').addClass('hidden');
    $('.emailaddress').removeClass('error-msg-textbox');
    $('.confirmemailaddress').removeClass('error-msg-textbox');
    $('.validbothtxt').addClass('hidden');

    if (email === '') {
      $('.emailtxt').removeClass('hidden');
      $('.emailaddress').addClass('error-msg-textbox');
      $('.emailtxtvalid').addClass('hidden');
      return false;
    } else if (!pattern.test(email)) {
      $('.emailaddress').addClass('error-msg-textbox');
      $('.emailtxtvalid').removeClass('hidden');
      $('.emailtxt').addClass('hidden');
      return false;
    }

    if (confirmemail === '') {
      $('.confirmemailaddress').addClass('error-msg-textbox');
      $('.confirmemailtxt').removeClass('hidden');
      $('.confirmemailtxtvalid').addClass('hidden');
      $('.validbothtxt').addClass('hidden');
      return false;
    } else if (!pattern.test(confirmemail)) {
      $('.confirmemailaddress').addClass('error-msg-textbox');
      $('.confirmemailtxt').addClass('hidden');
      $('.confirmemailtxtvalid').removeClass('hidden');
      $('.validbothtxt').addClass('hidden');
      return false;
    }

    if (email !== confirmemail) {
      $('.emailaddress').addClass('error-msg-textbox');
      $('.confirmemailaddress').addClass('error-msg-textbox');
      $('.validbothtxt').removeClass('hidden');
      $('.confirmemailtxtvalid').addClass('hidden');
      return false;
    }

    return true;
  }

  function validatePhone() {
    var phonenumber = $('.phonenumber').val();
    let tollFreeCodesRegex = JSON.parse($('#tollFreeCodes').val()).join('|');
    var phoneRegex = new RegExp(
      '^((?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4})$'
    );
    if (phonenumber === '' || phonenumber.length < 12) {
      $('.phonetxt-toll-error').addClass('hidden');
      $('.phonenumber').addClass('error-msg-textbox');
      $('.phonetxt').removeClass('hidden');
      return false;
    } else if (!phoneRegex.test(phonenumber)) {
      $('.phonenumber').removeClass('error-msg-textbox');
      $('.phonetxt').addClass('hidden');
      return false;
    } else {
      $('.phonenumber').removeClass('error-msg-textbox');
      $('.phonetxt').addClass('hidden');
      $('.phonetxt-toll-error').addClass('hidden');
      return true;
    }
  }

  function onsubmitForm() {
    if (!confirmEmailValidation()) {
      return false;
    }

    return validatePhone();
  }
  $('.existingUserRegistration_step2').on(
    'change input',
    '.existing-user-phone-number',
    function() {
      let tollFreeCodesRegex = JSON.parse($('#tollFreeCodes').val()).join('|');
      var phoneRegex = new RegExp(
        '^((?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4})$'
      );
      if (!phoneRegex.test($(this).val()) && $(this).val().length === 12) {
        $('.phonetxt').addClass('hidden');
        $('.phonetxt-toll-error').removeClass('hidden');
        $(this).addClass('error-msg-textbox');
      } else if (
        phoneRegex.test($(this).val()) &&
        $(this).val().length === 12
      ) {
        $('.phonetxt-toll-error').addClass('hidden');
        $(this).removeClass('error-msg-textbox');
      }
    }
  );
  $('.existingUserRegistration_step2').on(
    'input',
    '.emailaddress, .confirmemailaddress, .phonenumber',
    function() {
      const confirmEmail = confirmEmailValidation();
      const validatePh = validatePhone();
      if (confirmEmail && validatePh) {
        $('.next-btn').attr('disabled', false);
      } else {
        $('.next-btn').attr('disabled', true);
      }
    }
  );
  $('.next-btn').on('click', onsubmitForm);
});
